import Vue from 'vue'
import { PopupManager } from 'element-ui/src/utils/popup'
import UmBusRole from './api.vue'
const UmBusRoleConstructor = Vue.extend(UmBusRole) // 直接将Vue组件作为Vue.extend的参数
let instance
const instances = []
let seed = 1

const role = (options) => {
  options = options || {}
  const id = 'export_' + seed++
  console.log(options)
  instance = new UmBusRoleConstructor({
    data: options
  }) // 实例化
  instance.id = id
  instance.$mount()
  instance.visible = true
  document.body.appendChild(instance.$el)
  instance.$el.style.zIndex = PopupManager.nextZIndex()
  instances.push(instance)
  return instance
}
role.closeAll = function() {
  for (let i = instances.length - 1; i >= 0; i--) {
    instances[i].$destroy(true)
  }
}

export default {
  install: Vue => {
    Vue.prototype.$selectBusRole = role // 将组件暴露出去，并挂载在Vue的prototype上
  }
}
